import {
  CONSENT_FIELD_ALIASES,
  LEGACY_CONSENT_FIELD_ALIASES,
} from './consent.constants';

export type ConsentPayload = {
  acceptTnC: boolean;
  traceMarketing: boolean;
  partnerMarketing: boolean;
};

export type TraceConsentIdentity = {
  firebaseUid?: string | null;
  email?: string | null;
};

export type TraceConsentPayload = {
  firebase_uid: string;
  email: string;
  accept_tnc: boolean;
  trace_marketing: boolean;
  partner_marketing: boolean;
};

const toConsentBoolean = (value: unknown) =>
  value === true || value === '1' || value === 'true';

const readConsentBoolean = (
  formData: Record<string, any>,
  canonicalAlias: string,
  legacyAlias?: string,
) =>
  toConsentBoolean(formData[canonicalAlias]) ||
  (legacyAlias ? toConsentBoolean(formData[legacyAlias]) : false);

export const normalizeConsentPayload = (
  formData: Record<string, any>,
): ConsentPayload => ({
  acceptTnC: readConsentBoolean(
    formData,
    CONSENT_FIELD_ALIASES.terms,
    LEGACY_CONSENT_FIELD_ALIASES.terms,
  ),
  traceMarketing: readConsentBoolean(
    formData,
    CONSENT_FIELD_ALIASES.traceMarketing,
    LEGACY_CONSENT_FIELD_ALIASES.marketing,
  ),
  partnerMarketing: readConsentBoolean(
    formData,
    CONSENT_FIELD_ALIASES.partnerMarketing,
  ),
});

export const hasRequiredConsent = (consent: ConsentPayload) =>
  consent.acceptTnC === true;

export const buildTraceConsentPayload = (
  consent: ConsentPayload,
  identity: TraceConsentIdentity,
): TraceConsentPayload => {
  const firebaseUid = identity.firebaseUid?.trim();
  const email = identity.email?.trim();

  if (!firebaseUid || !email) {
    throw new Error('Missing consent identity');
  }

  return {
    firebase_uid: firebaseUid,
    email,
    accept_tnc: consent.acceptTnC,
    trace_marketing: consent.traceMarketing,
    partner_marketing: consent.partnerMarketing,
  };
};
